import { useAuth } from '../context/AuthContext';

export const usePermissions = () => {
  const { user } = useAuth();

  const hasPermission = (permission: string): boolean => {
    if (!user) return false;
    
    // Check direct permissions
    if (user.permissions?.some((p) => p.name === permission)) {
      return true;
    }

    // Check permissions via roles
    if (user.roles) {
      for (const role of user.roles) {
        if (role.permissions?.some((p) => p.name === permission)) {
          return true;
        }
      }
    }

    return false;
  };

  const hasAnyPermission = (permissions: string[]): boolean => {
    return permissions.some((permission) => hasPermission(permission));
  };

  const hasAllPermissions = (permissions: string[]): boolean => {
    return permissions.every((permission) => hasPermission(permission));
  };

  const hasRole = (roleName: string): boolean => {
    if (!user) return false;
    return user.roles?.some((role) => role.name === roleName) || false;
  };

  return {
    hasPermission,
    hasAnyPermission,
    hasAllPermissions,
    hasRole,
  };
};

